import { ADD_QUEUE_POSITION, ADD_QUEUE_POSITION_SUCCESS, ADD_QUEUE_POSITION_ERROR } from './actionTypes';

const initialState = {
  errorAddQueuePosition: '',
  loadingAddQueuePosition: false,
  successAddQueuePosition: '',
};

const addQueuePosition = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUEUE_POSITION:
      state = {
        ...state,
        loadingAddQueuePosition: true,
      };
      break;
    case ADD_QUEUE_POSITION_SUCCESS:
      state = {
        ...state,
        loadingAddQueuePosition: false,
        successAddQueuePosition: action.payload.message,
      };
      break;
    case ADD_QUEUE_POSITION_ERROR:
      state = { ...state, errorAddQueuePosition: action.payload, loadingAddQueuePosition: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default addQueuePosition;
